import React from "react";
import cs from "classnames";
import PropTypes from "prop-types";

import { Pill } from "@lululemon/ecom-pattern-library-pill";

import styles from "./product-description.module.scss";

export function ProductDescriptionPill({ label, tag, className, ...rest }) {
  return (
    <Pill {...rest} className={cs(styles.pdpTitlePill, className)} tag={tag}>
      {label}
    </Pill>
  );
}

ProductDescriptionPill.propTypes = {
  ...Pill.propTypes,
  children: PropTypes.node,
  show: PropTypes.bool.isRequired,
  label: PropTypes.node.isRequired,
  tag: PropTypes.string,
  className: PropTypes.string
};

ProductDescriptionPill.defaultProps = {
  children: null,
  tag: "span",
  className: ""
};
